export async function loadLocale(locale: string, localeSuffix: string): Promise<any> {
  return import(`@/i18n/${locale}-${localeSuffix}.ts`);
}
